import React from 'react'

const Attribution = () => {
  return (
    <div>
         <p class="attribution">
        Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel='noreferrer'>Frontend Mentor</a>. 
        Coded by <a href="https://walumyas.netlify.app" target='_blank' rel='noreferrer'>Yasin Walum</a>.
        </p>
    </div>
  )
}

export default Attribution